import React from 'react';
import { useIntl } from 'react-intl';
import { Col, Container, Row } from 'reactstrap';
import { SmartlinksMusicIndustriesList } from '../SmartlinksMusicIndustriesList';

export const SmartlinksLinkfireAlternativeBuiltFor: React.FC = () => {
  const intl = useIntl();

  return (
    <Container className="smartlinks-description mb-5 mt-5 pt-5">
      <Row>
        <Col>
          <p className="main-header text-center mb-3 mb-lg-5">
            {intl.formatMessage({
              id: 'sml.web.smart-links.linkfire_alternative.built-for.title',
              defaultMessage: 'Who is Music24 for?'
            })}
          </p>
          <p className="text-center" style={{ fontSize: '1.5rem' }}>
            {intl.formatMessage({
              id: 'sml.web.smart-links.linkfire_alternative.built-for.description',
              defaultMessage:
                'Music24 is the best Linkfire alternative for anyone who wants to share music with their fans and followers.'
            })}
          </p>
        </Col>
      </Row>
      <Row>
        <Col className="d-flex flex-wrap flex-row justify-content-center mt-5">
          <SmartlinksMusicIndustriesList />
        </Col>
      </Row>
    </Container>
  );
};
